"use client";

import { memo } from "react";
import { Box, HStack, VStack, Text } from "@chakra-ui/react";
import type { AtsJobDetails } from "../types";
import { SectionTitle } from "./SectionTitle";

export interface EducationSectionProps {
  educations: AtsJobDetails["educations"];
}

export const EducationSection = memo<EducationSectionProps>(
  ({ educations }) => {
    if (!educations || educations.length === 0) return null;

    return (
      <Box as="section" aria-label="Education" mb={6}>
        <SectionTitle title="Education" />
        <VStack align="stretch" gap={2}>
          {educations.map((edu, index) => {
            const graduationYear = edu.end_date
              ? new Date(edu.end_date).getFullYear()
              : "";
            return (
              <HStack
                key={`${edu.university}-${edu.major}-${index}`}
                justify="space-between"
                align="flex-start"
                wrap="wrap"
              >
                <VStack align="start" gap={0} flex={1}>
                  <Text
                    textStyle="sm"
                    fontWeight="600"
                    color="neutral.900"
                    lineHeight="1.5"
                  >
                    {edu.university}
                  </Text>
                  <Text textStyle="sm" color="neutral.500" lineHeight="1.5">
                    {edu.degree || edu.major}
                  </Text>
                </VStack>
                {graduationYear ? (
                  <Text
                    textStyle="sm"
                    color="neutral.500"
                    whiteSpace="nowrap"
                    textAlign="right"
                  >
                    {graduationYear}
                  </Text>
                ) : null}
              </HStack>
            );
          })}
        </VStack>
      </Box>
    );
  },
);
EducationSection.displayName = "EducationSection";
